<template>
    <component :is="el" v-bind="animRoot" class="flex flex-col gap-5">
        <intelligent-inbox-wizard-card :expandable="props.expandable">
            <template v-slot:header>
                <component :is="el" v-bind="animProps">Opportunity Detection</component>
            </template>
            <template v-slot:headerSubtitle>
                <component :is="el" v-bind="animProps"
                    >Define how the AI should detect engagement opportunities in conversations.</component
                >
            </template>
            <template v-slot:content>
                <div class="flex flex-col gap-6">
                    <component :is="el" v-bind="animProps">
                        <vx-label>Detection Guidelines</vx-label>
                        <vx-input
                            :modelValue="props.modelValue.detectionGuidelines"
                            @update:modelValue="update('detectionGuidelines', $event)"
                            size="lg"
                            :rows="6"
                            autoresize
                        ></vx-input>
                    </component>
                </div>
            </template>
        </intelligent-inbox-wizard-card>
    </component>
</template>

<script lang="ts" setup>
import { VxInput, VxLabel } from '@voxie/frontend-components';
import IntelligentInboxWizardCard from './IntelligentInboxWizardCard.vue';
import { motion } from 'motion-v';
import { computed } from 'vue';
import type { WizardData } from '../useIntelligentInbox';
import { fadeUpVariants, fieldStagger, quickTransition } from './wizardMotionVariants';

const props = withDefaults(
    defineProps<{
        modelValue: WizardData;
        animated?: boolean;
        expandable?: boolean;
    }>(),
    {
        animated: true,
        expandable: true,
    }
);

const el = computed(() => (props.animated ? motion.div : ('div' as const)));
const animRoot = computed(() =>
    props.animated ? { initial: 'hidden', animate: 'visible', transition: fieldStagger } : {}
);
const animProps = computed(() => (props.animated ? { variants: fadeUpVariants, transition: quickTransition } : {}));

const emit = defineEmits<{
    'update:modelValue': [value: WizardData];
}>();

const update = (key: keyof WizardData, value: string | number): void => {
    emit('update:modelValue', { ...props.modelValue, [key]: String(value) });
};
</script>
